<template>
  <div class="iv-question-score">
    <p class="iv-fs-16 iv-fc-85 iv-p-t-16 iv-p-b-16 iv-fw-6">
      <span v-if="item.isRequire == 1" style="color: red">* </span>
      [评价题]&nbsp;{{index + 1}}.&nbsp;{{item.questionName}}
    </p>
    <div class="iv-question-score-content iv-pos-r">
      <p class="iv-quetion-tips-p iv-fs-14 iv-fc-65 iv-pos-a" style="left: 0;top: -30px;">{{item.lowDesc}}</p>
      <div class="ivu-slider-stop iv-slider-active iv-pointer" style="left: 0%;" @click="specifyLocation(0)">
        <p>1</p>
      </div>
      <Slider ref="Slider" v-model="item.checkVal" show-tip="never" :step="1" :max="9" show-stops @on-change="sliderChange" :disabled="state != 1"></Slider>
      <div class="ivu-slider-stop iv-pointer" style="left: 100%;" @click="specifyLocation(10)">
        <p>10</p>
      </div>
      <p class="iv-quetion-tips-p iv-fs-14 iv-fc-65 iv-pos-a" style="right: 0;top: -30px;">{{item.highDesc}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 1
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    isRequire () {
      return this.item.isRequire == 1 ? '[必填]' : ''
    }
  },
  data () {
    return {
      checkVal: 0,
      state: 0
    }
  },
  created () {
    this.optionList = new Array(10).fill(1).map((val, index) => {
      return {
        value: index + 1,
        score: 10
      }
    })
    this.state = this.$route.query.state
    this.getCheckVal()
  },
  mounted () {
    const stopElements = this.$refs.Slider.$el.querySelectorAll('.ivu-slider-stop')
    for (let i = 0; i < stopElements.length; i++) {
      const pNode = document.createElement('p')
      const ele = stopElements[i]
      pNode.innerText = Number(i + 2)
      ele.append(pNode)
    }
  },
  methods: {
    // 获取checkVal
    getCheckVal () {
      for (let i of this.item.optionList) {
        if (this.item.userOptions[0] === i.optionOrder) {
          this.item.checkVal = i.optionInfo - 1
        }
      }
    },
    //手动添加类名实现样式
    sliderChange (val) {
      this.setStopStyle(val)
      this.$emit('change', this.item, this.index, true)
    },
    //第一个跟最后一个 手动设置
    specifyLocation (val) {
      this.checkVal = val
      this.setStopStyle(val)
    },
    // 改变样式
    setStopStyle (val) {
      const stopElements = this.$refs.Slider.$el.querySelectorAll('.ivu-slider-stop')
      for (let i = 0; i < stopElements.length; i++) {
        const ele = stopElements[i]
        if (val > i) {
          ele.classList.add('iv-slider-active')
        } else {
          if (ele.classList.contains('iv-slider-active')) {
            ele.classList.remove('iv-slider-active')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/base/variable.scss';
.iv-question-score {
  width: 50%;
  margin-bottom: 48px;
  .ivu-slider-stop {
    top: -4px;
    background: #fff;
    width: 12px;
    height: 12px;
    border: 2px solid #ccc;
    border-radius: 50%;
    background-color: #fff;
    transition: all .2s linear;
    outline: 0;
    z-index: 9;
    p {
      font-size: 16px;
      color: $black-85;
      margin-top: 20px;
      width: 20px;
    }
  }
  .iv-slider-active {
    border-color: $iv-main-color;
    p {
      color: $iv-main-color;
    }
  }
  .ivu-slider-bar {
    background-color: $iv-main-color;
  }
  .ivu-slider-button-wrap {
    top: -7px;
    z-index: 10;
    .ivu-slider-button {
      width: 18px;
      height: 18px;
      border-color: $iv-main-color !important;
    }
  }
}
</style>